import React from 'react';
import { Box, LinearProgress, Paper, Stack, Typography } from '@mui/material';
import { FiveKingdom } from './taxonomyDatabase';

interface ProgressTrackerProps { observedSpecimenIds: string[]; totalSpecimens: number; coveredKingdoms: FiveKingdom[]; }

const ProgressTracker: React.FC<ProgressTrackerProps> = ({ observedSpecimenIds, totalSpecimens, coveredKingdoms }) => {
  const progress = totalSpecimens ? Math.round((new Set(observedSpecimenIds).size / totalSpecimens) * 100) : 0;
  return <Paper variant="outlined" sx={{ p: 1.5, borderRadius: 1 }}>
    <Stack direction="row" justifyContent="space-between"><Typography variant="subtitle2" fontWeight={800}>Practical progress</Typography><Typography variant="caption">{new Set(observedSpecimenIds).size}/{totalSpecimens} specimens observed</Typography></Stack>
    <LinearProgress variant="determinate" value={progress} sx={{ mt: 1, height: 7, borderRadius: 1 }} aria-label="Specimen observation progress" />
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75, mt: 1 }}>{(['Monera', 'Protista', 'Fungi', 'Plantae', 'Animalia'] as FiveKingdom[]).map((kingdom) => <Typography key={kingdom} variant="caption" color={coveredKingdoms.includes(kingdom) ? 'success.main' : 'text.secondary'}>{coveredKingdoms.includes(kingdom) ? '✓ ' : '○ '}{kingdom}</Typography>)}</Box>
  </Paper>;
};

export default ProgressTracker;
